import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class QueuesService {
  constructor(private http: HttpClient) {}

  public query(params: any) {
    let projectId;

    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v5/projects/${projectId}/queues`;

    return this.http.get(url, { params });
  }
}
